module.exports = __webpack_public_path__ + "img/roll1.0fbfc108.jpeg";